export default (el) => {
  const bannerCol1 = el;

  $('.js-banner-col-1').each(function () {
    let countLink = $(this).find('a').length;
    let randomNbr = Math.floor(Math.random() * (countLink+1));
    if (randomNbr === 0) { randomNbr = 1;}

    $(this).find('a:nth-child(' + randomNbr + ')').removeClass('d-none').addClass('d-block');
  });
}
